import store from "@/store";

export class User
{
    private userLoaded = false;

    public async load(userKey: string): Promise<void>
    {
        this.userLoaded = true;
    }
}